import { Routes } from '@angular/router';
import { growthBookGuard } from './guards/growth-book.guard';
import { LoggedInRedirectGuard } from './guards/logged-in-redirect.guard';
import { NotFoundGuard } from './guards/not-found.guard';
import { PromoSaveGuard } from './guards/promo-save.guard';
import { TrackingIdGuard } from './guards/tracking-id.guard';
import { websiteMetaResolver } from './resolves/website-meta.resolver';

const allRoutes: Routes = [
  {
    path: '',
    redirectTo: '/a',
    pathMatch: 'full',
  },
  {
    path: 'a',
    loadChildren: () => import('./account/routes').then(m => m.routes),
    resolve: {
      meta: websiteMetaResolver,
    },
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/routes').then(m => m.routes),
    resolve: {
      meta: websiteMetaResolver,
    },
  },
  {
    path: '**',
    canActivate: [NotFoundGuard],
    loadComponent: () => import('./pages/not-found-page/not-found-page.component').then(m => m.NotFoundPageComponent),
    resolve: {
      meta: websiteMetaResolver,
    },
  },
];

export const appRoutes: Routes = [
  {
    path: '',
    canActivate: [LoggedInRedirectGuard, TrackingIdGuard, PromoSaveGuard, growthBookGuard],
    children: allRoutes,
  },
];
